module.exports = __webpack_public_path__ + "static/media/jdrManoir_01_thumb_hover.0967503d.png";